import { getCustomData } from 'shared/components/App/Auth'

const showUserSwitcher = (): boolean => {
  const showUserSwitcher = getCustomData('showUserSwitcher') ?? false

  return showUserSwitcher
}

export default showUserSwitcher
